import { MarketingPageLayout } from "./components/MarketingPageLayout";
import { BlogPreview } from "./sections/BlogPreview";
import { BottomCTA } from "./sections/BottomCTA";
import { FAQ } from "./sections/FAQ";
import { Hero } from "./sections/Hero";
import { HigherIntelligence } from "./sections/HigherIntelligence";
import { MeetTheCompanions } from "./sections/MeetTheCompanions";
import { PromptsStrip } from "./sections/PromptsStrip";
import { TreatsSection } from "./sections/TreatsSection";

export function HomePage() {
  return (
    <MarketingPageLayout current="home">
      <Hero />
      <MeetTheCompanions />
      <HigherIntelligence />
      <PromptsStrip />
      <TreatsSection />
      <BlogPreview />
      <BottomCTA />
      <FAQ />
    </MarketingPageLayout>
  );
}
